<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
              class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>Editar post</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <!--Images-->
        <div class="mb-5">
          <div class="grid grid-cols-2 -mx-2">
            <div class="p-2">
              <template v-if="document.image1">
                <div class="img-container flex items-center justify-center">
                  <img :src="document.image1" alt="img" class="responsive">
                </div>
                <div class="modify-img flex justify-between mt-5">
                  <span style="cursor: pointer" class="mr-2" type="flat" color="#999"
                        @click="document.image1=null">Eliminar</span>
                </div>
              </template>
            </div>
          </div>
          <div class="grid grid-cols-2 -mx-2">
            <div class="upload-img mt-5 p-2" v-if="!document.image1">
              <input id="image1" type="file" class="hidden" ref="uploadImgInput1" @change="updateImage"
                     accept="image/*">
              <vs-button style="width: 100%" @click="$refs.uploadImgInput1.click()">Imagen (1080x1350)</vs-button>
            </div>
          </div>
        </div>

        <!-- Video -->
        <div class="mb-5">
          <label class="text-sm opacity-75">Video</label>
          <template v-if="document.muxPlaybackId">
            <div class="mt-2 flex items-center">
              <img :src="`https://image.mux.com/${document.muxPlaybackId}/thumbnail.jpg?width=200`"
                   alt="video thumbnail" class="rounded-lg" style="height: 60px;">
              <span class="ml-3 text-success text-sm">Video listo</span>
              <span style="cursor: pointer" class="ml-auto text-danger text-sm" @click="removeVideo">Eliminar video</span>
            </div>
          </template>
          <template v-else-if="videoUploading">
            <div class="mt-2">
              <vs-progress :percent="videoUploadProgress" color="primary"></vs-progress>
              <p class="text-sm text-center mt-1" v-if="videoUploadProgress < 100">Subiendo video... {{ videoUploadProgress }}%</p>
              <p class="text-sm text-center mt-1" v-else>Procesando video en Mux...</p>
            </div>
          </template>
          <template v-else>
            <div class="mt-2">
              <input type="file" class="hidden" ref="videoInput" @change="uploadVideo" accept="video/*">
              <vs-button style="width: 100%" type="border" icon-pack="feather" icon="icon-video"
                         @click="$refs.videoInput.click()">
                Subir video
              </vs-button>
            </div>
          </template>
        </div>

        <!-- Title -->
        <div class="mb-5">
          <vs-input @blur="document.title= trimString(document.title)" label="Título*"
                    v-model="document.title"
                    class="w-full" name="title"
                    v-validate="'required|min:3|max:150'"/>
          <span class="text-danger text-sm"
                v-show="errors.has('title')">{{ errors.first('title') }}</span>
        </div>

        <!-- Description -->
        <div class="mb-5">
          <vs-input @blur="document.description= trimString(document.description)" label="Descripción (extracto)*"
                    v-model="document.description"
                    class="w-full" name="description"
                    v-validate="'required|min:5|max:500'"/>
          <span class="text-danger text-sm"
                v-show="errors.has('description')">{{ errors.first('description') }}</span>
        </div>

        <!-- Body -->
        <div class="mb-5">
          <label class="text-sm opacity-75">Contenido*</label>
          <quill-editor v-model="document.body"
                        class="w-full mt-2"
                        name="body"
                        v-validate="'required|min:5'"/>
          <span class="text-danger text-sm"
                v-show="errors.has('body')">{{ errors.first('body') }}</span>
        </div>

        <!-- Associated Products -->
        <div class="mb-5">
          <label class="text-sm opacity-75">Productos asociados</label>
          <v-select multiple
                    label="label"
                    :options="products"
                    v-model="selectedProducts"
                    :reduce="product => ({ id: product.id, name: product.name, image1: product.image1, slug: product.slug, categorySlug: product.categorySlug })"
                    placeholder="Buscar productos..."
                    class="mt-2"/>
        </div>

      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || progress || videoUploading">Guardar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
      <div v-if="progress" style="margin-top: 1rem; width: 100%">
        <vs-progress indeterminate color="primary"></vs-progress>
      </div>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import trimString from '../../mixins/trimString'
import vSelect from 'vue-select'
import axios from 'axios'

import { auth, db, FieldValue, storage } from '@/firebase/firebaseConfig'

import { quillEditor } from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

const MUX_FUNCTIONS_BASE = 'https://southamerica-east1-camelia-69abc.cloudfunctions.net'

export default {
  name: 'UpdatePost',
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    },
    products: {
      type: Array,
      default: () => []
    }
  },
  components: {
    VuePerfectScrollbar,
    vSelect,
    quillEditor
  },
  mixins: [trimString],
  data () {
    return {
      document: {},
      selectedProducts: [],
      newImage1: null,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      progress: false,
      videoUploading: false,
      videoUploadProgress: 0
    }
  },
  watch: {
    isSidebarActive (val) {
      if (val) {
        this.document = {
          ...this.data
        }
        this.initValues()
        this.$validator.reset()
      }
    },
    document: {
      handler () {
        if (this.document.image1 === null) {
          this.newImage1 = null
        }
      },
      deep: true
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid () {
      return !this.errors.any()
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    async submitData () {
      try {
        const result = await this.$validator.validateAll()
        if (result) {
          this.progress = true
          if (this.newImage1 != null) {
            this.document.image1 = await this.submitImages(this.newImage1)
          }

          let obj = {
            ...this.document,
            associatedProducts: this.selectedProducts,
            uid: auth.currentUser.uid,
            updatedAt: FieldValue.serverTimestamp()
          }

          await db.collection('posts').doc(this.document.id).update({
            ...obj
          })

          this.$emit('update', obj)
          this.$emit('closeSidebar')

          this.$vs.notify({
            color: 'success',
            title: 'Posts',
            text: 'Post modificado correctamente.'
          })
        }
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      } finally {
        this.progress = false
      }
    },
    async uploadVideo (input) {
      const file = input.target.files && input.target.files[0]
      if (!file) return

      try {
        this.videoUploading = true
        this.videoUploadProgress = 0

        const { data } = await axios.post(`${MUX_FUNCTIONS_BASE}/mux-createUpload`)

        await axios.put(data.uploadUrl, file, {
          headers: { 'Content-Type': file.type },
          onUploadProgress: (progressEvent) => {
            this.videoUploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          }
        })

        const playbackId = await this.pollMuxAsset(data.uploadId)

        this.$set(this.document, 'muxUploadId', data.uploadId)
        this.$set(this.document, 'muxPlaybackId', playbackId)

        this.$vs.notify({
          color: 'success',
          title: 'Video',
          text: 'Video subido correctamente.'
        })
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Error al subir el video.'
        })
      } finally {
        this.videoUploading = false
        this.videoUploadProgress = 0
        if (this.$refs.videoInput) {
          this.$refs.videoInput.value = ''
        }
      }
    },
    async pollMuxAsset (uploadId) {
      const maxAttempts = 60
      for (let i = 0; i < maxAttempts; i++) {
        await new Promise(resolve => setTimeout(resolve, 3000))
        try {
          const { data } = await axios.get(`${MUX_FUNCTIONS_BASE}/mux-getAsset`, {
            params: { uploadId }
          })
          if (data.playbackId) {
            this.$set(this.document, 'muxAssetId', data.assetId)
            return data.playbackId
          }
        } catch (e) {
          // Ignore errors and keep polling
        }
      }
      throw new Error('Video processing timeout')
    },
    removeVideo () {
      this.$set(this.document, 'muxPlaybackId', null)
      this.$set(this.document, 'muxAssetId', null)
      this.$set(this.document, 'muxUploadId', null)
    },
    submitImages (image) {
      return new Promise((resolve, reject) => {
        let imageName = Math.random().toString(36).substr(1, 20)
        let fileExtension = '.' + image.name.split('.').pop()
        let imageNameFinal = imageName + fileExtension

        let storageRef = storage.ref(`posts/${imageNameFinal}`)
        storageRef.put(image)
            .then((snapshot) => {
              snapshot.ref.getDownloadURL().then((url) => {
                resolve(url)
              })
            })
            .catch((error) => {
              reject(error)
            })
      })
    },
    updateImage (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = (e) => {
          if (input.srcElement.id === 'image1') {
            this.$set(this.document, 'image1', e.target.result)
            this.newImage1 = input.target.files[0]
            if (this.newImage1.size > 5000000) {
              this.document.image1 = null
              this.newImage1 = null

              this.$vs.notify({
                color: 'warning',
                title: '¡Oh no!',
                text: 'Imagen supera máximo de 5MB'
              })
            }
          }
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    initValues () {
      if (!this.document.image1)
        this.$set(this.document, 'image1', null)

      if (this.document.associatedProducts && this.document.associatedProducts.length > 0) {
        this.selectedProducts = this.document.associatedProducts.map(p => {
          const found = this.products.find(prod => prod.id === (p.id || p))
          if (found) {
            return { id: found.id, name: found.name, image1: found.image1 }
          }
          return p
        })
      } else {
        this.selectedProducts = []
      }

      this.newImage1 = null
      this.videoUploading = false
      this.videoUploadProgress = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 650px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
